import AdditionalInformation from "./AdditionalInformation"
import AgreementOverview from "./AgreementOverview"
import DocusealSigningForm from "./DocusealSigningForm"
import InsuranceAndRegistration from "./InsuranceAndRegistration"
import SelectPaymentMethod from "./SelectPaymentMethod"
import SignAgreement from "./SignAgreement"
import SignAndComplete from "./SignAndComplete"
import ViewContractDetails from "./ViewContractDetails"
import { evaluateRequiredStep } from "./requiredStepValidation"

export { evaluateRequiredStep } from "./requiredStepValidation"

const ReviewStep = (agreementOverview) => ({
  title: "Review",
  key: "review",
  validate: (state) => state.contractDetailsSeen,
  component: agreementOverview ? AgreementOverview : ViewContractDetails,
})

const PayStep = {
  title: "Payment Method",
  key: "pay",
  validate: (state) => {
    if (state.paymentMethod === "manual" || state.paymentType === "manual") {
      return state.paymentType === "manual" && state.paymentMethod === "manual"
    }
    return (
      state.paymentMethod !== "" &&
      state.paymentMethod !== "add" &&
      state.paymentType === "credit"
    )
  },
  component: SelectPaymentMethod,
}

const InsuranceAndRegistrationStep = (quote) => ({
  title: "Insurance & Registration",
  key: "required",
  validate: (state) => evaluateRequiredStep(state, quote).valid,
  component: InsuranceAndRegistration,
})

const AdditionalInformationStep = (quote) => {
  return {
    title: "Additional Information",
    key: "additional",
    validate: (state) => {
      const { additionalInformation } = state
      const { contractSigningEnablements } = quote

      return contractSigningEnablements
        .filter((enablement) => enablement.required)
        .every((enablement) => {
          const { customFieldDefinitionId } = enablement
          return (
            additionalInformation[customFieldDefinitionId] &&
            additionalInformation[customFieldDefinitionId] !== ""
          )
        })
    },
    component: AdditionalInformation,
  }
}

const SignAndCompleteStep = {
  title: "Sign & Complete",
  key: "sign",
  validate: (state) => {
    const { signature, dockwaTermsAccepted, marinaTermsAccepted } = state
    return signature !== "" && dockwaTermsAccepted && marinaTermsAccepted
  },
  component: SignAndComplete,
}

const DocusealSignAgreementStep = {
  title: "Sign Agreement",
  key: "sign",
  validate: (state) =>
    state.docusealFormCompleted || state.docusealFormSubmitted || false,
  component: DocusealSigningForm,
}

const SignAgreementStep = {
  title: "Sign Agreement",
  key: "sign",
  validate: (state) => state.reviewReady,
  component: SignAgreement,
}

const shouldShowInsuranceAndRegistrationStep = (quote) => {
  const { registrationRequired, insuranceRequired, phoneInvalid } = quote

  return registrationRequired || insuranceRequired || phoneInvalid
}

const shouldShowAdditionalInformationStep = (quote) => {
  const { contractSigningEnablements } = quote
  return contractSigningEnablements && contractSigningEnablements.length > 0
}

const getSteps = (quote, withTemplate, agreementOverview) => {
  const steps = [ReviewStep(agreementOverview), PayStep]

  if (shouldShowInsuranceAndRegistrationStep(quote)) {
    steps.push(InsuranceAndRegistrationStep(quote))
  }

  if (shouldShowAdditionalInformationStep(quote)) {
    steps.push(AdditionalInformationStep(quote))
  }

  if (withTemplate) {
    steps.push(
      agreementOverview ? SignAgreementStep : DocusealSignAgreementStep
    )
  } else {
    steps.push(SignAndCompleteStep)
  }

  return steps
}

export default getSteps
